var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"google-places-input",staticClass:"form-control mb-4",attrs:{"type":"text","placeholder":"Enter a location."},on:{"keyup":_vm.searchChange}})}
var staticRenderFns = []

export { render, staticRenderFns }